import { render } from "./HeroiconsSolidDuplicate.vue?vue&type=template&id=f4d94354"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDuplicate.vue"]])

export default __exports__